export default "__VITE_ASSET__B0b7V36d__"